import Image1 from "../image/jakuzi/image1.webp";
import Image2 from "../image/jakuzi/image2.webp";
import Image3 from "../image/jakuzi/image3.webp";

export const JakuzziData = [
  {
    id: 1,
    image: Image1,
    alt: "Image jakuzzi 1",
  },
  {
    id: 2,
    image: Image2,
    alt: "Image jakuzzi 2",
  },
  {
    id: 3,
    image: Image3,
    alt: "Image jakuzzi 3",
  },
  
];
